import { render, staticRenderFns } from "./Spotlight.vue?vue&type=template&id=764654d2&scoped=true&"
import script from "./Spotlight.vue?vue&type=script&lang=js&"
export * from "./Spotlight.vue?vue&type=script&lang=js&"
import style0 from "./Spotlight.vue?vue&type=style&index=0&id=764654d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764654d2",
  null
  
)

export default component.exports